import { render, staticRenderFns } from "./UpdateCompanyIntroduction.vue?vue&type=template&id=5c9c8955&scoped=true"
import script from "./UpdateCompanyIntroduction.vue?vue&type=script&lang=js"
export * from "./UpdateCompanyIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9c8955",
  null
  
)

export default component.exports